<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Настройки
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="createItem()">
                        <v-icon small>mdi-plus</v-icon>
                        Добавить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="pb-sm-2" v-for="account in this.settings.length > 0 ? this.settings[0].balance_info : []">
            <v-col>
                <h2 class="title is-3">
                    Денег на аккаунте {{ account.name }}: {{ account.balance }} {{ account.currency }}
                </h2>
            </v-col>
        </v-row>
        <v-data-table :headers="headers" :items="settings" sort-by="id" class="elevation-4">
            <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Редактировать</span>
                </v-tooltip>

                <v-tooltip top v-if="!item.is_default">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                    <span>Удалить</span>
                </v-tooltip>
            </template>

            <template v-slot:item.is_default="{ item }">
                <v-switch small :readonly="item.is_default" v-model="item.is_default" @change="setDefaultItem(item)"></v-switch>
            </template>
        </v-data-table>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: 'AdminSettingsList',
    components: {
        OverlayLoader,
    },
    data() {
        return {
            headers: [
                { text: "Default", value: "is_default", sortable: false },
                { text: "ID", align: "start", sortable: true, value: "id" },
                { text: "Название", sortable: false, value: "name" },
                { text: "Описание", sortable: false, value: "description" },
                { text: "Действия", value: "actions", sortable: false },
            ],
        };
    },
    created() {
        this.$store.dispatch('GET_SETTINGS_LIST');
    },
    computed: {
        settings() {
            return this.$store.getters.SETTINGS_LIST;
        },
        isLoading() {
            return this.$store.getters.SETTINGS_LOADING;
        },
    },
    methods: {
        editItem(settings) {
            this.$router.push({ name: "UpdateSettings", params: { id: settings.id } });
        },
        createItem() {
            this.$router.push({ name: "CreateSettings" });
        },
        setDefaultItem(settings) {
            this.$store.dispatch('SET_DEFAULT_SETTINGS', settings)
                .finally(() => this.$store.dispatch('GET_SETTINGS_LIST'));
        },
        deleteItem(settings) {
            this.$store.dispatch('DELETE_SETTINGS', settings)
                .finally(() => this.$store.dispatch('GET_SETTINGS_LIST'));
        }
    }
}
</script>

<style>

</style>
